import axios, {AxiosResponse, InternalAxiosRequestConfig} from 'axios';
import {store} from '../redux/store';
import {baseUrl} from './api';
import {endSession} from '../screens/auth/login/actions';
import {cacheKey, getCache, setCache} from '../utils/axiosCache';
import {tr} from '../translation';

// Create a cache using a Map
const cache = new Map();

/**
 * create new axios instance.
 * @type {AxiosInstance}
 */
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    // 'Cache-Control': 'no-cache, no-store, must-revalidate',
    // Pragma: 'no-cache',
    // Expires: '0',
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'X-Device-OS': 'web',
  },
});
axiosInstance.defaults.timeout = 120000;
axiosInstance.defaults.timeoutErrorMessage = tr('app.timoutError');
/**
 * create interceptor for request to add token.
 */
axiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig<any>) => {
    const tempConfig = {...config};

    const {currentUser} = store.getState().auth || {};
    if (currentUser?.dashboardToken) {
      tempConfig.headers.Authorization = `Bearer ${currentUser.dashboardToken}`;
      const cachedResponse = getCache(cacheKey(tempConfig), cache);
      if (cachedResponse) {
        return Promise.reject({cachedResponse});
      }
    }

    return tempConfig;
  },
  (error: any) => {
    Promise.reject(error);
  },
);
/**
 * create axios interceptor to response for refresh token.
 */
axiosInstance.interceptors.response.use(
  async (response: AxiosResponse<any, any>) => {
    const method = (response?.config?.method || '').toLowerCase();
    if (method === 'get') {
      setCache(cacheKey(response?.config), response, cache);
    }
    return response;
  },
  async (error: any) => {
    if (error?.cachedResponse) {
      return Promise.resolve(error?.cachedResponse);
    }
    if (error?.response?.status === 401) {
      await endSession();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
